import { executeSend, canQueryData, generateExecuteRequest } from "../../helpers";
// Note: When testing RESTClient or, component that uses RESTClient
// window.navigator.onLine needs to be mocked
export class RESTClient {
    constructor(options) {
        this.clearCachedMessage = (message) => {
            delete this.cachedMessages[message];
        };
        this.retryInterval = options.retryInterval || 1000;
        this.maxRetryAttempts = options.maxRetryAttempts || 5;
        this.handlers = options.handlers;
        this.cachedMessages = {};
    }
    connect() {
        return Promise.resolve(canQueryData());
    }
    deactivate() {
        return Promise.resolve(true);
    }
    isConnected() {
        return Promise.resolve(canQueryData());
    }
    isConnectedSync() {
        return canQueryData();
    }
    send(message) {
        const stringifiedMessage = JSON.stringify(message);
        if (typeof this.cachedMessages[stringifiedMessage] === "undefined") {
            this.cachedMessages[stringifiedMessage] = new Promise((resolve, reject) => {
                void executeSend({
                    request: generateExecuteRequest(message, this.handlers.requestFormatter, this.handlers.responseFormatter),
                    resolve: (x) => {
                        this.clearCachedMessage(stringifiedMessage);
                        resolve(x);
                    },
                    reject: (x) => {
                        this.clearCachedMessage(stringifiedMessage);
                        reject(x);
                    },
                    retryAttempt: 0,
                    retryInterval: this.retryInterval,
                    maxRetryAttempts: this.maxRetryAttempts
                });
            });
        }
        return this.cachedMessages[stringifiedMessage];
    }
}
//# sourceMappingURL=RESTClient.js.map